import {Col, Flex, Row, Grid, Image} from "antd";
import { useEffect, useState } from "react";
import SectionMainImg from '../../../../assets/images/pages/Main/section2-5.webp'
import {MyButton, MyImage, MyText} from "../../../common";
import {ArrowRightOutlined} from "@ant-design/icons";
import {WaveContainer} from "../WaveContainer";
import SectionImg1 from '../../../../assets/images/pages/Main/section2-img1.webp'
import SectionImg2 from '../../../../assets/images/pages/Main/section2-img2.webp'
import SectionImg3 from '../../../../assets/images/pages/Main/section2-img3.webp'
import SectionSpin1 from '../../../../assets/images/pages/Main/section1-spin1.webp'
import SunIcon from '../../../../assets/images/pages/Main/sun-icon.svg'
import TalkIcon from '../../../../assets/images/pages/Main/talk-icon.svg'
import EyeIcon from '../../../../assets/images/pages/Main/eye-icon.svg'

import {useTranslation} from "react-i18next";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useEmbeddedNavigate } from "../../../../utils/context/embed";
import { HoverRow, OrangeButton } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { fetchMaterialsTreeAction, RootState, selectStore } from "../../../../utils";
const isMobile = window.innerWidth < 768;


export const Section2 = () => {
  const {t} = useTranslation("common")
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  const dispatch = useDispatch();
  const [materials, setMaterials] = useState<any[]>([]);
  const [materialsList, setMaterialsList] = useState<any[]>([]);
  const {materials: {materialsTree: materialsTreeState}}: RootState = useSelector(selectStore);
  const tree = materialsTreeState?.data?.tree || [];
  const materials5List = materialsTreeState?.data?.materials5List || [];
  // const [array, setArray] = useState<{ text: string; url: string }[]>([]);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isTablet = screens.md && !screens.xl && !screens.xxl;
  const icons = [SunIcon, TalkIcon, EyeIcon];

 const descriptions = [
  t("supportCognitiveEmotional"),
  t("speechAndVocabularyExercises"),
  t("visualSupportTasks"),
];

const type5Item = tree.find((item: any) => item.type === "5");

const array =
  type5Item?.id && materials5List.length
    ? materials5List.map((item: any) => ({
        text: item.name,
        url: `/materials/detail?id=${item.id}`,
      }))
    : [
        {
          text: t("severeSpeechDisorders"),
          url: "#",
        },
        {
          text: t("visualImpairment"),
          url: "#",
        },
        {
          text: t("mentalDevelopmentDelay"),
          url: "#",
        },
      ];

  // useEffect(() => {
  //   const fetchContent = async () => {
  //     try {
  //       const response = await fetchMaterials(undefined);
  //       const materialsList = response.tree || [];
        

  //       setMaterials(materialsList);
  
  //       const arrayFirst = [
  //         {
  //           text: `${t("severeSpeechDisorders")}`,
  //           url: '#',
  //         },
  //         {
  //           text: `${t("visualImpairment")}`,
  //           url: '#',
  //         },
  //         {
  //           text: `${t("mentalDevelopmentDelay")}`,
  //           url: '#',
  //         }
  //       ]
      
  //       setArray(arrayFirst)

  //       const type5Item = materialsList.find(item => item.type === "5");
  
  //       if (type5Item?.id) {
  //         const secondResponse = await fetchMaterials(type5Item.id);
  //         const materials5List = secondResponse.tree || [];
  //         setMaterialsList(materials5List);

  //         const updatedArray = materials5List.map(item => ({
  //           text: item.name,
  //           url: `/materials/detail?id=${item.id}`,
  //         }));
  //         setArray(updatedArray);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching materials:', error);
  //     }
  //   };
  
  //   fetchContent();
  // }, []);

  useEffect(() => {
    dispatch(fetchMaterialsTreeAction(undefined));
  }, [dispatch]);

  return (
    <WaveContainer
      containerStyle={{
        backgroundColor: '#fff',
        paddingTop: 200,
        paddingBottom: screens.xs ? 0 : 200,
        zIndex: 0
      }}>
      <Row justify='center'>
        <Col span={20}>
          <Row gutter={[32, 32]} align='middle' style={screens.xs ? { display: 'flex', flexDirection: 'column' } : {}}>
            <Col span={screens.xxl ? 11 : 13} style={screens.xs ? { maxWidth: '100%' } : {}}>
              <Row gutter={[40, 40]}>
                <Col span={24} style={{textAlign: screens.xs ? 'center' : 'left',}}>
                  <MyText color='#0A033C' size={screens.xs || isTablet ? 32 : 48} lineHeight={screens.xs || isTablet ? '34px' : '64px'} weight={800}
                          style={{fontFamily: 'Nunito', position: 'relative', zIndex: 1,}}>
                    {t("childrenWithSpecialNeeds")}
                  </MyText>
                </Col>

                <Col span={screens.xxl ? 24 : 23}>
                  <Row gutter={[16, 16]}>
                    {array.map((item, index) => (
                      <Col span={24} key={index}>
                        <HoverRow
  align="middle"
  justify="space-between"
  gutter={[8, 8]}
  onClick={() => embeddedNavigate(item.url)}
>

                          <Col span={4}>
                          <Image
                            src={icons[index]}
                            preview={false}
                            width={screens.xs || isTablet ? 54 : 88}
                            height={ screens.xs || isTablet ? 54 : 88}
                          />
                          </Col>
                          <Col span={screens.xs || isTablet ? 18 : 10}>
                            <Row gutter={[8,8]}>
                              <Col>
                              <MyText color='rgba(10, 3, 60, 1)' size={screens.xs || isTablet ? 16 : 18} weight={500} style={screens.xs ? { width: '80%'} : {}}>
                              {item.text}
                            </MyText>
                              </Col>
                              <Col>
                              <MyText color='rgba(104, 114, 125, 1)' size={screens.xs || isTablet ? 14 : 16} weight={500} style={screens.xs ? { width: '80%'} : {}}>
                              {descriptions[index]}
                            </MyText>
                              </Col>
                            </Row>
                          </Col>

                          <Col span={screens.xs || isTablet ? 24 : 8}>
                          <OrangeButton onClick={() => embeddedNavigate(item.url)} justify="center" align="middle">
                            <MyText className="btn-text" size={16} weight={500}>
                              {t("goToTasks")}
                            </MyText>
                          </OrangeButton>
                          </Col>
                        </HoverRow>
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>
            </Col>

            <Col span={screens.xxl ? 13 : 11} style={screens.xs ? { maxWidth: '100%', marginTop: '30px' } : {maxWidth: '100%',}}>
              <img
                src={SectionMainImg}
                style={{
                  width:'100%',
                  transform:'translateX(5%)',
                  display: 'block'
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </WaveContainer>
  )
}